export default __webpack_public_path__ + "static/media/gangdonggu-seongnaedong-station-activation-2.a33beded.jpg";